/** React-select styles that follow `.donezo-workflow-page` CSS variables (light + dark). */
const workflowSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: "var(--wf-input-bg, #fff)",
    border: "1px solid var(--wf-input-border, #ccc)",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
    marginTop: 0,
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "45px",
    backgroundColor: "var(--wf-input-bg, #fff)",
    color: "var(--wf-input-text, #374151)",
    borderColor: state.isFocused
      ? "var(--wf-input-border-focus, var(--bs-primary))"
      : "var(--wf-input-border, #dee2e6)",
    boxShadow: state.isFocused ? "0 0 0 3px var(--wf-input-ring, rgba(27, 94, 32, 0.12))" : "none",
    "&:hover": {
      borderColor: "var(--wf-input-border-focus, #aaa)",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--wf-input-text, #374151)",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "var(--wf-chip-bg, #dcfce7)",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "var(--wf-chip-text, #14532d)",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "var(--wf-chip-text, #14532d)",
    ":hover": {
      backgroundColor: "var(--wf-chip-remove-hover, #bbf7d0)",
      color: "var(--wf-chip-text, #14532d)",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--wf-text-muted, #9ca3af)",
  }),
  input: (provided) => ({
    ...provided,
    color: "var(--wf-input-text, #374151)",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "var(--wf-input-border, #dee2e6)",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "var(--wf-text-muted, #9ca3af)",
    ":hover": {
      color: "var(--wf-input-text, #374151)",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "var(--wf-text-muted, #9ca3af)",
    ":hover": {
      color: "var(--wf-input-text, #374151)",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "var(--wf-option-selected-bg, #dcfce7)"
      : state.isFocused
        ? "var(--wf-option-hover-bg, #f3f4f6)"
        : "var(--wf-input-bg, #fff)",
    color: "var(--wf-input-text, #374151)",
    cursor: "pointer",
  }),
};

export default workflowSelectStyles;
